<template>
  <ApModal v-model="modal" centered hide-header-close hide-footer>
    <template #modal-title>
      {{ $t('modal.inactivity.title') }}
    </template>
    <template #default>
      <NotificationBadge
        class="mx-0 badge-color-warning"
        :text="badgeText"
        color="warning-400"
      ></NotificationBadge>
      <p class="text-base text-blue-500 mb-3 mt-3">
        {{ $t('modal.inactivity.content') }}
      </p>
    </template>
  </ApModal>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
// @ts-expect-error: vuex is not typped. It will be migrated to typed pinia in the future.
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import ApModal from '@/components/widgets/ApModal.vue'
import NotificationBadge from '@/components/widgets/NotificationBadge.vue'

const store = useStore()
const { t } = useI18n()

const modal = ref(false)

const isInactivityModalVisible = computed(() => store.getters['auth/isInactivityModalVisible'])
const timeToLogout = computed(() => store.getters['auth/timeToLogout'])
const badgeText = computed(() => t('modal.inactivity.logoutIn', { time: timeToLogout.value }))

watch(isInactivityModalVisible, (newValue) => {
  modal.value = !!newValue.modal
})
</script>
<style scoped></style>
